import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { readStoredJson } from "../../utils/GenericFunctions";
import { initTheme } from "../../utils/theme";

/**
 * Syncs document.body with theme-uae class when United Arab Emirates (AE) is selected.
 * Login page color combination (purple/dark/amber) is then applied globally via CSS.
 */
const CountryThemeSync = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    initTheme();
    const countryVo = readStoredJson("countryVo");
    const isUAE =
      countryVo &&
      Object.keys(countryVo).length > 0 &&
      countryVo.shortCode === "AE";
    if (isUAE) {
      document.body.classList.add("theme-uae");
    } else {
      document.body.classList.remove("theme-uae");
    }
  }, [location.pathname]);

  return children || null;
};

export default CountryThemeSync;
